// Delivery dates, shown live while the customer is still choosing.
//
// The rules themselves (how many days, which days don't count) come from
// the API - see /api/catalog and backend/delivery.py, which is the single
// definition. Only the loop lives here, because the order page recalculates
// on every keystroke and can't ask the server each time.
//
// The weekday numbers are JavaScript's: Date.getDay() counts from Sunday,
// so Sunday is 0. Python's date.weekday() counts from Monday, where Sunday
// is 6 - the backend converts before sending, so nothing here has to know.

export const DEFAULT_RULES = { days: 2, no_delivery_weekdays: [0] };

/** Parses "2026-09-30" as local midnight. Plain new Date("2026-09-30")
 *  parses as UTC, which lands on the day before in western timezones. */
export function parseDay(value) {
  return value ? new Date(`${value}T00:00:00`) : null;
}

/** Counts forward `days` days that things actually move on, skipping the
 *  ones nothing is delivered on. */
export function addDeliveryDays(start, rules = DEFAULT_RULES) {
  const skip = rules.no_delivery_weekdays || [];
  const day = new Date(start.getTime());
  let counted = 0;
  while (counted < rules.days) {
    day.setDate(day.getDate() + 1);
    if (!skip.includes(day.getDay())) counted += 1;
  }
  return day;
}

/** When a pickup / everything-in-one-go order lands, if paid for today. */
export function orderEta(rules) {
  return addDeliveryDays(new Date(), rules);
}

/** When a split order lands, for a chosen deadline. Everything goes out
 *  together once sign-ups close, so the board and every painter's canvas
 *  arrive on this same day. */
export function splitEta(deadlineValue, rules) {
  const deadline = parseDay(deadlineValue);
  return deadline ? addDeliveryDays(deadline, rules) : null;
}
